<script setup>
import { CloseOutlined } from '@ant-design/icons-vue';

const props = defineProps({
  closable: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(['close']);
</script>

<template>
  <a-row
    class="drawer-title"
    style="padding-top: 10px; padding-left: 24px; padding-right: 24px"
  >
    <a-col :span="22">
      <slot name="title" />
    </a-col>
    <a-col :span="2" style="text-align: right; padding-top: 8px">
      <CloseOutlined
        v-if="props.closable"
        style="line-height: 37px; font-size: 16px"
        @click="emit('close')"
      />
    </a-col>
  </a-row>
  <a-divider style="margin-top: 10px" />
</template>
